import React from 'react';
import { withAuth } from '@okta/okta-react';
import { withAlert } from 'react-alert';
import CrudForm from '../../Crud/Form';
export default withAuth(withAlert()(class EditForm extends CrudForm {
  constructor() {
    super(...arguments);
    this.formType = () => this.props.title;
    this.getCrudType = () => 'attachments';
    this.getLabelColumns = () => 3;
    this.getFieldColumns = () => 7;
    this.successAlertMsg = data => ['Attachment updated successfully', 'success'];
    this.buildApiVariables = () => ({
      uuid: this.state.item.uuid,
      name: this.state.item.name,
      description: this.state.item.description
    });
    this.modalBodyRows = () => /*#__PURE__*/React.createElement("div", null, this.getTextFieldRow('name', 'Name', true), this.getTextareaRow('description', 'Description', false), /*#__PURE__*/React.createElement("br", null));
  }
}));